(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      /* STELBO: `preventHide` era citit in onScroll (`if (this.preventHide) return;`)
         dar nu era setat nicaieri, deci ramanea undefined si `hide()` rula
         intotdeauna la scroll in jos. Efectul: headerul disparea la derulare
         chiar si cu setarea "always". */
      this.preventHide = this.headerIsAlwaysSticky;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      /* STELBO: `setHeaderHeight` rula o singura data, in `connectedCallback` —
         adica INAINTE ca logoul si fonturile sa fie incarcate, cand wrapperul
         are inca ~1px. `--header-height` ramanea cu acea valoare pentru tot
         restul sesiunii, iar sertarul de mobil, care isi calculeaza marginea de
         sus din ea, pornea de sub bara in loc de sub header.

         Un ResizeObserver o tine sincronizata cu inaltimea reala, inclusiv cand
         headerul isi schimba starea la derulare. Fallback pe `load` pentru
         browserele fara ResizeObserver. */
      if ('ResizeObserver' in window) {
        this.heightObserver = new ResizeObserver(this.setHeaderHeight.bind(this));
        this.heightObserver.observe(this);
      } else {
        window.addEventListener('load', this.setHeaderHeight.bind(this));
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      /* STELBO: masura `.section-header`, care pe homepage are inaltime 0 —
         headerul pluteste `position: absolute` peste video, deci sectiunea nu
         are continut in flux. `--header-height` iesea `0px`, iar tot ce se
         bazeaza pe ea calcula gresit: sertarul de mobil ajungea sa inceapa la
         28px in loc de ~106px, si `.shopify-section-header-hidden` isi calcula
         gresit offsetul de ascundere.

         Wrapperul (`this`, adica <sticky-header>) are inaltimea reala. Luam
         valoarea mai mare dintre cele doua, ca sa fim corecti si pe paginile
         unde sectiunea e cea care poarta inaltimea. */
      /* STELBO: in timpul condensarii la derulare (logo 240 ms) ResizeObserver-ul
         raporta in fiecare cadru, iar fiecare scriere pe :root invalida stilul
         intregii pagini. Prima masuratoare se scrie imediat; urmatoarele doar
         dupa ce inaltimea se stabilizeaza (150 ms) si doar daca s-a schimbat.
         Consumatorii variabilei (sertarul, starea ascunsa) nu au nevoie de ea
         cadru cu cadru. */
      var self = this;
      var write = function () {
        var wrapperHeight = self.offsetHeight || 0;
        var sectionHeight = self.header ? self.header.offsetHeight : 0;
        var height = Math.max(wrapperHeight, sectionHeight);
        if (height > 0 && height !== self.stHeaderHeight) {
          self.stHeaderHeight = height;
          document.documentElement.style.setProperty('--header-height', height + 'px');
        }
      };
      if (!this.stHeaderHeight) return write();
      clearTimeout(this.stHeightTimer);
      this.stHeightTimer = setTimeout(write, 150);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.heightObserver) this.heightObserver.disconnect();
    }

    createObserver() {
      /* STELBO: pe homepage `.section-header` are inaltime 0 — headerul
         pluteste `position: absolute` peste video (stelbo.css, sectiunea 4).
         Un dreptunghi de inaltime 0 nu raporteaza niciodata o intersectie
         utila, deci `this.headerBounds` ramanea `{}`. In `onScroll`, toate
         cele trei ramuri compara cu `headerBounds.bottom` / `.top`; fata de
         `undefined` orice comparatie e falsa, deci clasa `scrolled-past-header`
         nu se adauga NICIODATA pe homepage. Consecinta in lant: wrapperul
         ramane absolut, `.section-header` ramane cu inaltime 0, iar
         `.search-modal` (care e `height: 100%`) primea 2px — de aici panoul
         de cautare prost pozitionat la derulare pe telefon.

         Reparatia: pornim de la o masuratoare sincrona a wrapperului, care
         are inaltime reala, si lasam observatorul doar sa o rafineze. */
      this.headerBounds = this.getBoundingClientRect();

      let observer = new IntersectionObserver((entries, observer) => {
        const rect = entries[0].intersectionRect;
        if (rect && rect.height > 0) this.headerBounds = rect;
        observer.disconnect();
      });

      observer.observe(this);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stelbo-google-reviews"] && !Shopify.designMode) return;
  try {
    
  class StelboReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.hidden = false;
      this.next.hidden = false;

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          this.measureClamps();
          this.sync();
        });
        this.ro.observe(this.track);
      }

      this.setupClamps();
      this.sync();
    }

    /* Butonul "Vezi continuarea" apare doar daca textul chiar e taiat. Se
       masoara dupa randare, pentru ca depinde de latimea cardului, si se
       remasoara la redimensionare — pe un ecran mai lat acelasi text poate
       sa incapa. */
    setupClamps() {
      this.clamps = [...this.querySelectorAll('[data-text]')].map((text) => {
        const more = text.nextElementSibling;
        if (!more || !more.hasAttribute('data-more')) return null;

        more.addEventListener('click', () => {
          const open = text.classList.toggle('is-open');
          more.textContent = open ? 'Vezi mai putin' : 'Vezi continuarea';
          more.setAttribute('aria-expanded', String(open));
          this.sync();
        });

        more.setAttribute('aria-expanded', 'false');
        return { text, more };
      }).filter(Boolean);

      this.measureClamps();
    }

    measureClamps() {
      if (!this.clamps) return;

      this.clamps.forEach(({ text, more }) => {
        // Un text deja deschis nu se mai masoara: ar parea ca incape.
        if (text.classList.contains('is-open')) return;
        more.hidden = text.scrollHeight - text.clientHeight <= 2;
      });
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    get reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    step(direction) {
      const card = this.track.querySelector('[data-card]');
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

      this.track.scrollBy({
        left: direction * amount,
        behavior: this.reduced ? 'auto' : 'smooth',
      });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;

      // Banda are padding lateral, ca stralucirea si ridicarea cardului la
      // hover sa nu fie taiate. Cu scroll-snap, primul card se opreste la
      // marginea continutului, deci pozitia de repaus e chiar padding-ul, nu
      // zero — altfel sageata "inapoi" ramane activa desi nu e nimic in
      // spate. Se citeste din CSS: pe telefon padding-ul e mai mare.
      const styles = getComputedStyle(this.track);
      const start = parseFloat(styles.paddingInlineStart || styles.paddingLeft) || 0;

      // Cei 2px de toleranta: pe ecrane cu scalare fractionara scrollLeft nu
      // atinge niciodata exact maximul.
      const atStart = this.track.scrollLeft <= start + 2;
      const atEnd = this.track.scrollLeft >= max - 2;
      const noOverflow = max <= 2;

      this.prev.disabled = atStart || noOverflow;
      this.next.disabled = atEnd || noOverflow;
      this.classList.toggle('stelbo-gr--static', noOverflow);
    }
  }

  if (!customElements.get('stelbo-reviews')) {
    customElements.define('stelbo-reviews', StelboReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
